const faqData = [
  {
    question: "Da li je krema protiv bora i dnevna i noćna?",
    answer:
      "Kremu protiv bora nanosite ujutro i naveče u tankom sloju, nakon čišćenja lica, i to na cijelo lice, područje oko očiju i dekolte. Krema ima bogatu, a ne vodenastu teksturu, zbog čega se nanosi u tankom sloju.",
  },
  {
    question: "Koliko često nanosim zeolitnu masku?",
    answer:
      "Zeolitnu masku/piling nanosiš jednom do dva puta sedmično prije spavanja. Dobro umasiraš na lice i dekolte i ostaviš tako preko noći (ne vidi se na licu, kao da si nanijela kremicu). Ujutru očistiš lice i naneseš kombinaciju seruma i kremice ili samo kremu Mamazapet.",
  },
  {
    question: "Da li serum zbog ulja masti lice?",
    answer:
      "Serum u kombinaciji sa kremicom i maskom uklanja mitisere i bubuljice i sprečava nastanak novih. Serum hidrira i tonira lice u roku od nekoliko sekundi. Brzo se upija i ne ostavlja masni trag. Sadrži vitamin E, umiruje kožu. Miriše predivno i Mama za pet ga koristi kao neku vrstu terapije prije spavanja.",
  },
  {
    question: "Da li proizvode mogu da koriste i tinejdžeri?",
    answer:
      "Roditelji za tinejdžere uzimaju kremicu i masku. Utiske imate i u recenzijama. Kremicu nanose, nakon čišćenja lica, ujutru i naveče u tankom sloju. Zeolitnu masku/piling nanose jednom do dva puta sedmično prije spavanja. Ne vidi se na licu, kao da su nanijeli kremicu. Maska može i svako veče na bubuljice.",
  },
  {
    question: "Da li proizvode mogu da koriste i muškarci?",
    answer:
      "Naravno. Nakon brijanja, krema i serum umiruju kožu, ublažavaju crvenilo, a zeolitna maska jednom sedmično pilinguje kožu i dubinski čisti pore. Rezultat je zdrava koža i ujednačen ten.",
  },
  {
    question: "Da li Mama za pet set mogu da koriste trudnice i porodilje?",
    answer:
      "Sasvim sigurno je da je za vas najbolje da tokom trudnoće i dojenja koristite samo prirodne proizvode, nasuprot agresivne hemije. Međutim, ako imate bilo kakvih nedoumica pitajte svog ljekara.",
  },
];

export default faqData;
